import React, { useState } from "react";
import {
  Form,
  InputContainer,
  Button,
  Content,
  Row,
  ButtonBack,
  Table,
} from "./UserMovementsElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectId,
  selectToken,
  setNewToken,
} from "../../features/user/userSlice";
import axios from "axios";
import { API_URL } from "../../const/api";
import moment from "moment";
import {
  infoNotification,
  warningNotification,
} from "../../utils/toastNotifications";
import Loader from "../common/Loader";
import { getFormattedDate, toLocale } from "../../utils/tools";
import { setShowUserMenuMobile } from "../../features/modals/modalsSlice";

const MovementsContent = (props) => {
  const [t] = useTranslation("global");
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const dispatch = useDispatch();
  const [fechaInicial, setFechaInicial] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [fechaFinal, setFechaFinal] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const goBack = () => {
    const scrollmcontents = document.getElementById("root");
    scrollmcontents.scrollIntoView({ behavior: "smooth" });
    dispatch(setShowUserMenuMobile(true));
  };

  const cargarDatos = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (
      moment(fechaInicial, true).isValid() &&
      moment(fechaFinal, true).isValid()
    ) {
      const body = {
        id_uo,
        token,
        fechaInicial,
        fechaFinal,
      };
      const res = await axios.post(API_URL + "loadMovimientos", body);
      dispatch(setNewToken(res.data.token));
      if (res.data.status === 1) {
        setLoading(false);
        if (Array.isArray(res.data.response)) {
          setResults(res.data.response);
        } else {
          infoNotification(res.data.response);
        }
      }
    } else {
      setLoading(false);
      warningNotification(t("movements.valida"));
    }
  };

  return (
    <>
      <Form>
        <Row>
          <InputContainer>
            <label>{t("movements.desde")}:</label>
            <input
              type="date"
              value={fechaInicial}
              onChange={(e) => {
                setFechaInicial(e.target.value);
              }}
              required
            />
          </InputContainer>
          <InputContainer>
            <label>{t("movements.hasta")}:</label>
            <input
              type="date"
              value={fechaFinal}
              onChange={(e) => setFechaFinal(e.target.value)}
              required
            />
          </InputContainer>
        </Row>
        <Button onClick={cargarDatos}>{t("movements.buscar")}</Button>
      </Form>
      <Content>
        <Table>
          <thead>
            <tr>
              <th>{t("movements.fecha")}</th>
              <th>{t("movements.hora")}</th>
              <th>{t("movements.descripcion")}</th>
              <th>{t("movements.debito")}</th>
              <th>{t("movements.credito")}</th>
              <th>{t("movements.saldo")}</th>
            </tr>
          </thead>
          <tbody>
            {results.length > 0 &&
              results.map((item) => {
                let [ fecha, hora ] = getFormattedDate(item.fecha, item.hora);
                fecha = fecha.replace(/\//g, '-');
                return (
                  <tr key={item.id} className="row">
                    <td>{fecha}</td>
                    <td>{hora}</td>
                    <td className="wrap">{item.descripcion}</td>
                    <td>{toLocale(parseFloat(item.debito))}</td>
                    <td>{toLocale(parseFloat(item.credito))}</td>
                    <td>{toLocale(parseFloat(item.saldo))}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
        {loading && <Loader />}
      </Content>
      {!props.btnBack && (
        <ButtonBack onClick={goBack}>{t("movements.volver")}</ButtonBack>
      )}
    </>
  );
};

export default MovementsContent;
